import { render, staticRenderFns } from "./oscity-documentos.vue?vue&type=template&id=c6e8b47e&scoped=true&"
import script from "./oscity-documentos.vue?vue&type=script&lang=js&"
export * from "./oscity-documentos.vue?vue&type=script&lang=js&"
import style0 from "./oscity-documentos.vue?vue&type=style&index=0&id=c6e8b47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e8b47e",
  null
  
)

export default component.exports